import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["role", "tabindex"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseIcon',
  props: {
    disabled: { type: Boolean },
    clickable: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    color: { default: '#969696' },
    name: {},
    sizeClass: {},
    height: {},
    width: {},
    fontSize: { default: '24' }
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const emitClick = (event: MouseEvent) => {
  if (props.disabled) return;
  emit('click', event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    onClick: emitClick
  }, [
    _renderSlot(_ctx.$slots, "icon"),
    (!_ctx.$slots.icon)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass([[_ctx.sizeClass, { 'has-click': !_ctx.disabled && _ctx.clickable, left: _ctx.left, right: _ctx.right, disabled: _ctx.disabled }], "v-icon"]),
          role: _ctx.clickable ? 'button' : undefined,
          style: _normalizeStyle([
        { color: _ctx.color },
        { height: `${_ctx.height}px` },
        { width: `${_ctx.width}px` },
        { fontSize: `${_ctx.fontSize}px` },
      ]),
          tabindex: _ctx.clickable ? 0 : undefined
        }, _toDisplayString(_ctx.name), 15, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}
}

})